// Libraries statiques pour éviter les rechargements
export const GOOGLE_MAPS_LIBRARIES: ["places"] = ["places"];

// Fonction utilitaire pour vérifier si Google Maps est chargé
export const isGoogleMapsLoaded = (): boolean => {
  return !!(window.google && window.google.maps && window.google.maps.places);
}; 